webpackJsonp([185949985728563],{

/***/ 1689:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CensusKennelEdge","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"cursor","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"node","type":{"kind":"OBJECT","name":"CensusKennel","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-census-kennel-edge-c2d3e3f95fc5ef236276.js